import Head from 'next/head';

import useParams from 'legacy/common/hooks/useParams';
import CreateEvent from 'legacy/events/screens/CreateEvent.screen';

export const CreateEventPage = () => {
  const { eventId, orgId, startDate } = useParams<{
    eventId: string;
    orgId: string;
    startDate: string;
  }>();

  return (
    <div>
      <Head>
        <title>Create Event</title>
      </Head>

      <CreateEvent eventId={eventId} orgId={orgId} startDate={startDate} />
    </div>
  );
};

export default CreateEventPage;
